import React from 'react'
import './Dices.css'

export default function Dices(props) {
    const styles = {
        backgroundColor: props.isHeld ? "#59E391" : "#fff"
    }
  return (
        <div className='dice-cover' 
        style={styles}
        onClick={props.holdDice}
        >
            <h2 className='dice-face'>{props.value}</h2>

        </div>
    
  )
}
